module.exports = __webpack_public_path__ + "images/background/login__background--ocean-6f1ed2cfdefd8cbd4acebf821d9357f1.jpg";